import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { LoyaltyInfo } from '@/core/payment-card/interfaces';

@Component({
    data() {
        return {
            selectedOffers: []
        };
    }
})
export default class LoyaltyMultipleOffers extends Vue {
    @Prop(Object)
    loyaltyInfo: LoyaltyInfo;

    @Prop(Number)
    amount: number;

    @Prop(Boolean)
    loading: boolean;

    selectedOffers: Array<string>;

    get currentPointsUsed() {
        return this.loyaltyInfo.offers.reduce(
            (total, offer) => total + this.selectedOfferAmount(offer.offerCode) * offer.requiredPoints, 0
        );
    }

    get currentDiscountAmount() {
        return this.loyaltyInfo.offers.reduce(
            (total, offer) => total + this.selectedOfferAmount(offer.offerCode) * offer.discountAmount, 0
        );
    }

    removeOffer(offer) {
        if (!this.loading) {
            const index = this.selectedOffers.indexOf(offer.offerCode);

            if (index > -1) {
                this.selectedOffers.splice(index, 1);
            }
        }
    }

    addOffer(offer) {
        if (!this.isOfferDisabled(offer) && !this.loading) {
            this.selectedOffers.push(offer.offerCode);
        }
    }

    selectedOfferAmount(offerCode) {
        return this.selectedOffers.filter((offer) => offer === offerCode).length;
    }

    isOfferDisabled(offer) {
        return !this.loyaltyInfo.availablePoints ||
            (this.loyaltyInfo.availablePoints - this.currentPointsUsed - offer.requiredPoints < 0) ||
            !(this.selectedOffers.length < this.loyaltyInfo.maxRedeemableOffers) ||
            !(this.amount * 100 - this.currentDiscountAmount - offer.discountAmount >= 1);
    }

    @Watch('selectedOffers')
    onChangeSelectedOffers() {
        this.$emit('input', this.currentDiscountAmount);
        this.$emit('select', this.selectedOffers);
    }
}
